import { useMemo } from 'react';

import { ColumnSort } from '@tanstack/react-table';

import { convertSorts } from '@c/table/utilities/convert-sorts.util';

import { ISort } from '@t/api/common';

import { getSorts } from 'utilities/sorts';

export const useGetSortItems = <TData = unknown>(sortValue: string | ISort<TData>[] | undefined) => {
  return useMemo(() => {
    if (typeof sortValue === 'string') {
      return convertSorts(getSorts(sortValue));
    }

    return (sortValue?.map(({ direction, field: id }) => ({ desc: direction === 'desc', id })) as ColumnSort[]) ?? [];
  }, [sortValue]);
};
